module.exports = __webpack_public_path__ + "static/img/d.ee72ce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/d.png
// module id = HTqj
// module chunks = 1